module.exports = __webpack_public_path__ + "static/img/IMG_20160820_192024.02dd3791.jpg";